<script lang="ts">
  import { page } from '$app/state';

  import type { Product } from '@agapi/mlc-core';
  import { stack, hstack } from '@agapi/ui/panda/patterns';
  import { css } from '@agapi/ui/panda/css';

  import * as m from '$lib/parachute/messages';

  import { getLocaleFromUrl, getLocaleFormattedPrice, rewriteUrl } from '../../../utils';
  import { Markdown, styledMarkdownOverride } from '../../../components';

  const { product }: { product: Product } = $props();

  const locale = getLocaleFromUrl(page.url);
</script>

<div class={stack({ gap: { base: 'tight' }, pt: '3' })}>
  <div class={stack({ gap: '3' })}>
    <div class={hstack({ justifyContent: 'space-between', position: 'relative' })}>
      {#if product.brand.handle}
        <a href={rewriteUrl(page, `/brand/${product.brand.handle}`)} class={css({ fontSize: 'lg', lineHeight: 'none', color: 'forms.action', textDecoration: 'underline' })}>
          {product.brand.name}
        </a>
      {:else}
        <span class={css({ fontSize: 'lg', lineHeight: 'none', color: 'text.subdued' })}>
          {product.brand.name}
        </span>
      {/if}

      {#key product.variants[0].sku}
        <div id="lipscore-rating"
          data-ls-product-name={product.name}
          data-ls-brand={product.brand.name}
          data-ls-product-id={product.id ?? product.variants[0].sku}
          data-ls-product-url={page.url.toString()}
          data-ls-sku={product.variants[0].sku}
          class={css({ position: 'absolute!', right: 0, top: "-6" })}
        >
        </div>
      {/key}
    </div>

    <h1 class={css({ textStyle: 'h2' })}>
      {product.name}
    </h1>

    <span class={css({ fontSize: 'xs', color: 'text.subdued' })}>
      {m.articleNumber()}: {product.variants[0].sku}
    </span>
  </div>

  <div class={stack({ gap: '2' })}>
    {#if product.description.short}
      <Markdown value={product.description.short} css={styledMarkdownOverride} />
    {/if}
  </div>

  <div class={hstack()}>
    {#if product.variants[0].price.discount}
      <span class={css({ textStyle: 'h4', fontFamily: 'body', color: 'commerce.campaign.text' })}>
        {getLocaleFormattedPrice(product.variants[0].price, locale).totalPrice}
      </span>
      <span class={css({ textStyle: 'h5', fontFamily: 'body', textDecoration: 'line-through', color: 'text.subdued', fontWeight: 'normal' })}>
        {getLocaleFormattedPrice(product.variants[0].price, locale).originalPrice}
      </span>
    {:else}
      <span class={css({ textStyle: 'h4', fontFamily: 'body', color: 'primary.vibrant' })}>
        {getLocaleFormattedPrice(product.variants[0].price, locale).totalPrice}
      </span>
    {/if}
  </div>
</div>
